import { render, staticRenderFns } from "./SectionLink.vue?vue&type=template&id=74628194"
import script from "./SectionLink.vue?vue&type=script&lang=js"
export * from "./SectionLink.vue?vue&type=script&lang=js"
import style0 from "./SectionLink.vue?vue&type=style&index=0&id=74628194&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports